import React from 'react';
import mascotImage from '../../../../images/mascot/mascot@2x.png';

const EmptyListUi = () => (
  <div className='empty-list-wrapper text-center mt-5'>
    <img className='mascot-image' src={mascotImage} alt='mascot' />
    <h2 className='title'>No prospects found</h2>
  </div>
)

export default EmptyListUi


// WEBPACK FOOTER //
// ./src/components/app/prospectsList/EmptyListUi/index.js